/**
 * AR-210: per-route document titles.
 *
 * `index.html` ships a single `<title>AIVIA</title>`, so every screen used to
 * announce itself as "AIVIA" (WCAG 2.4.2). `titleForPath` names the known
 * routes; anything not listed falls back to the page's own `<main> h1` text,
 * which RouteAnnouncer reads after the new page renders.
 */
const EXACT: Record<string, string> = {
  '/': 'Home',
  '/threads': 'Threads',
  '/finances': 'Invoices',
  '/finances/invoices': 'Invoices',
  '/finances/invoices/new': 'Create New Invoice',
  '/finances/snapshot': 'Financial Snapshot',
  '/finances/statements': 'Statements',
  '/finances/unclaimed-commissions': 'Unclaimed Commissions',
  '/profile': 'Profile',
  '/user-preferences': 'User Preferences',
  '/settings/team': 'Team Management',
  '/product-updates': "What's New",
  '/admin': 'Admin Overview',
  '/admin/users': 'User Management',
  '/admin/content': 'Content Management',
  '/admin/prompts': 'Prompt Library',
  '/admin/product-updates': 'Product Updates',
  '/admin/feature-gates': 'Feature Gates',
  '/admin/cost-dashboard': 'Cost Dashboard',
  '/admin/mcp-tools': 'MCP Tools',
  '/admin/skills': 'Skills Management',
  '/admin/sync-error-log': 'Sync Error Log',
  '/admin/audit': 'Audit Logs',
  '/admin/chat-export': 'Chat Export',
  '/login': 'Sign in',
};

const PATTERNS: Array<[RegExp, string]> = [
  [/^\/finances\/invoices\/trips\/[^/]+\/edit$/, 'Edit Trip'],
  [/^\/finances\/invoices\/[^/]+\/edit$/, 'Edit Invoice'],
  [/^\/admin\/users\/[^/]+$/, 'User Record'],
];

export const APP_TITLE = 'AIVIA';

export function titleForPath(pathname: string): string | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (EXACT[path]) return EXACT[path];
  for (const [re, title] of PATTERNS) {
    if (re.test(path)) return title;
  }
  return null;
}

export function formatDocumentTitle(pageTitle: string | null | undefined): string {
  const t = (pageTitle ?? '').replace(/\s+/g, ' ').trim();
  return t ? `${t} · ${APP_TITLE}` : APP_TITLE;
}
